// extracted by mini-css-extract-plugin
export default {"info":"nFiuw","text":"z9Wk7","item":"ONaKJ","itemWithBorder":"_1Wb8","icon":"edpx8","difficultyIcon":"m2KQt"};